import { getPaths, getProps } from "@up/data";

import Page from "../[uid]";

export async function getStaticPaths() {
  return getPaths((page) => {
    return Boolean(page.uid.match("-college-credit"));
  });
}

export async function getStaticProps(context) {
  return getProps(context, `${context.params.uid}-college-credit`);
}

export default Page;
